const Instances = require("../data/game/instances.json");

export default {
	Instances,
};
